/* Net Worth Tracker & Calculator Logic — Math, Charts & CSV Export */

let nwDonutChart = null;
let nwGrowthChart = null;

function getNwInputs() {
  const getVal = (id, def = 0) => {
    const el = document.getElementById(id);
    if (!el) return def;
    const v = +el.value;
    return isNaN(v) ? def : v;
  };

  return {
    cash: getVal('nwCash', 500000),
    stocks: getVal('nwStocks', 2500000),
    pf: getVal('nwPf', 1000000),
    property: getVal('nwProperty', 8000000),
    otherAssets: getVal('nwOtherAssets', 1000000),
    homeLoan: getVal('nwHomeLoan', 4000000),
    autoLoan: getVal('nwAutoLoan', 300000),
    creditDebt: getVal('nwCreditDebt', 50000),
  };
}

function updateNwUrlParams(params) {
  try {
    const url = new URL(window.location);
    url.searchParams.set('cash', params.cash);
    url.searchParams.set('stocks', params.stocks);
    url.searchParams.set('pf', params.pf);
    url.searchParams.set('property', params.property);
    url.searchParams.set('otherAssets', params.otherAssets);
    url.searchParams.set('homeLoan', params.homeLoan);
    url.searchParams.set('autoLoan', params.autoLoan);
    url.searchParams.set('creditDebt', params.creditDebt);
    window.history.replaceState({}, '', url);
  } catch (e) {}
}

function parseNwUrlParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const getNum = (key) => {
    const val = searchParams.get(key);
    return val !== null ? +val : null;
  };

  return {
    cash: getNum('cash'),
    stocks: getNum('stocks'),
    pf: getNum('pf'),
    property: getNum('property'),
    otherAssets: getNum('otherAssets'),
    homeLoan: getNum('homeLoan'),
    autoLoan: getNum('autoLoan'),
    creditDebt: getNum('creditDebt'),
  };
}

function calculateNw(params) {
  const { cash, stocks, pf, property, otherAssets, homeLoan, autoLoan, creditDebt } = params;

  const totalAssets = cash + stocks + pf + property + otherAssets;
  const totalLiabilities = homeLoan + autoLoan + creditDebt;
  const netWorth = totalAssets - totalLiabilities;

  const debtToAssetRatio = totalAssets > 0 ? (totalLiabilities / totalAssets) * 100 : 0;

  const items = [
    { cat: 'Asset', name: 'Cash & Savings', value: cash, share: totalAssets > 0 ? (cash / totalAssets) * 100 : 0 },
    { cat: 'Asset', name: 'Stocks & Mutual Funds', value: stocks, share: totalAssets > 0 ? (stocks / totalAssets) * 100 : 0 },
    { cat: 'Asset', name: 'Retirement Funds (EPF/PPF)', value: pf, share: totalAssets > 0 ? (pf / totalAssets) * 100 : 0 },
    { cat: 'Asset', name: 'Real Estate Equity', value: property, share: totalAssets > 0 ? (property / totalAssets) * 100 : 0 },
    { cat: 'Asset', name: 'Gold & Physical Assets', value: otherAssets, share: totalAssets > 0 ? (otherAssets / totalAssets) * 100 : 0 },
    { cat: 'Liability', name: 'Home Loan Outstanding', value: homeLoan, share: totalLiabilities > 0 ? (homeLoan / totalLiabilities) * 100 : 0 },
    { cat: 'Liability', name: 'Auto & Personal Loans', value: autoLoan, share: totalLiabilities > 0 ? (autoLoan / totalLiabilities) * 100 : 0 },
    { cat: 'Liability', name: 'Credit Cards & Debt', value: creditDebt, share: totalLiabilities > 0 ? (creditDebt / totalLiabilities) * 100 : 0 },
  ];

  return {
    totalAssets: Math.round(totalAssets),
    totalLiabilities: Math.round(totalLiabilities),
    netWorth: Math.round(netWorth),
    debtToAssetRatio: +debtToAssetRatio.toFixed(1),
    items,
  };
}

function updateDisplays(params) {
  const setTxt = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  setTxt('nwCashDisplay', fmt(params.cash));
  setTxt('nwStocksDisplay', fmt(params.stocks));
  setTxt('nwPfDisplay', fmt(params.pf));
  setTxt('nwPropertyDisplay', fmt(params.property));
  setTxt('nwOtherAssetsDisplay', fmt(params.otherAssets));
  setTxt('nwHomeLoanDisplay', fmt(params.homeLoan));
  setTxt('nwAutoLoanDisplay', fmt(params.autoLoan));
  setTxt('nwCreditDebtDisplay', fmt(params.creditDebt));
}

function renderNwResults(result, params) {
  const setTxt = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  setTxt('nwVerdictHeadline', `Net Worth: ${fmt(result.netWorth)}`);
  setTxt('nwVerdictDetail', `With total assets of ${fmt(result.totalAssets)} and total liabilities of ${fmt(result.totalLiabilities)}, your financial net worth is ${fmt(result.netWorth)}.`);

  setTxt('nwTotalAssetsStatValue', fmt(result.totalAssets));
  setTxt('nwTotalLiabilitiesStatValue', fmt(result.totalLiabilities));
  setTxt('nwAssetsMetricValue', fmt(result.totalAssets));
  setTxt('nwLiabilitiesMetricValue', fmt(result.totalLiabilities));
  setTxt('nwRatioMetricValue', `${result.debtToAssetRatio}%`);

  renderTable(result.items);

  try {
    if (typeof Chart !== 'undefined') {
      renderDonutChart(params.cash, params.stocks, params.pf, params.property, params.otherAssets);
      renderGrowthChart(result.totalAssets, result.totalLiabilities, result.netWorth);
    }
  } catch (err) {
    console.warn('Net Worth Chart rendering error:', err);
  }
}

function renderDonutChart(cash, stocks, pf, property, otherAssets) {
  const ctx = document.getElementById('nwDonutChart');
  if (!ctx) return;

  if (nwDonutChart) nwDonutChart.destroy();

  nwDonutChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['Savings', 'Stocks/MFs', 'Retirement', 'Real Estate', 'Gold/Vehicles'],
      datasets: [
        {
          data: [cash, stocks, pf, property, otherAssets],
          backgroundColor: ['#3B82F6', cssVar('--chart-buy'), '#8B5CF6', '#F59E0B', '#EC4899'],
          borderColor: cssVar('--bg-card'),
          borderWidth: 3,
          hoverOffset: 4,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: { color: cssVar('--chart-tick'), usePointStyle: true, pointStyle: 'circle', padding: 12 },
        },
        tooltip: {
          backgroundColor: cssVar('--tooltip-bg'),
          borderColor: cssVar('--tooltip-border'),
          borderWidth: 1,
          titleColor: cssVar('--tooltip-title'),
          bodyColor: cssVar('--tooltip-body'),
          callbacks: {
            label: (ctx) => `${ctx.label}: ${fmt(ctx.raw)}`,
          },
        },
      },
      cutout: '72%',
    },
  });
}

function renderGrowthChart(totalAssets, totalLiabilities, netWorth) {
  const ctx = document.getElementById('nwGrowthChart');
  if (!ctx) return;

  if (nwGrowthChart) nwGrowthChart.destroy();

  nwGrowthChart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Financial Overview'],
      datasets: [
        {
          label: 'Total Assets',
          data: [totalAssets],
          backgroundColor: cssVar('--chart-buy'),
          borderRadius: 6,
        },
        {
          label: 'Total Liabilities',
          data: [totalLiabilities],
          backgroundColor: cssVar('--chart-rent'),
          borderRadius: 6,
        },
        {
          label: 'Net Worth',
          data: [netWorth],
          backgroundColor: '#8B5CF6',
          borderRadius: 6,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
          align: 'end',
          labels: { color: cssVar('--chart-tick'), usePointStyle: true, pointStyle: 'circle', padding: 16 },
        },
        tooltip: {
          backgroundColor: cssVar('--tooltip-bg'),
          borderColor: cssVar('--tooltip-border'),
          borderWidth: 1,
          titleColor: cssVar('--tooltip-title'),
          bodyColor: cssVar('--tooltip-body'),
          callbacks: {
            label: (ctx) => `${ctx.dataset.label}: ${fmt(ctx.raw)}`,
          },
        },
      },
      scales: {
        x: {
          grid: { color: cssVar('--chart-grid') },
          ticks: { color: cssVar('--chart-tick') },
        },
        y: {
          grid: { color: cssVar('--chart-grid') },
          ticks: {
            color: cssVar('--chart-tick'),
            callback: (v) => fmtCompact(v),
          },
        },
      },
    },
  });
}

function renderTable(items) {
  const tbody = document.getElementById('nwScheduleBody');
  if (!tbody) return;

  tbody.innerHTML = items.map((row) => `
    <tr>
      <td><span class="badge ${row.cat === 'Asset' ? 'badge-sip' : 'badge-lumpsum'}">${row.cat}</span></td>
      <td>${row.name}</td>
      <td class="${row.cat === 'Asset' ? 'advantage-buy' : 'advantage-renter'}">${fmt(row.value)}</td>
      <td>${row.share.toFixed(1)}%</td>
    </tr>
  `).join('');
}

function exportNwCsv() {
  const params = getNwInputs();
  const result = calculateNw(params);
  const headers = ['Category', 'Item Name', 'Value', 'Share Percent'];
  const rows = result.items.map((r) => [r.cat, r.name, r.value, `${r.share.toFixed(1)}%`]);

  const csv = [headers, ...rows].map((r) => r.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `net-worth-breakdown.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

function applyNwCountryRanges(country, overrideParams = {}) {
  if (!country) return;
  const curr = country.currency || 'USD';

  let defaultProperty = 8000000;
  let maxPropertyPrice = 50000000; // Cap property price at 5 Cr (50,000,000)

  if (curr === 'INR') {
    defaultProperty = 8000000;
    maxPropertyPrice = 50000000;
  } else if (curr === 'JPY') {
    defaultProperty = 80000000;
    maxPropertyPrice = 500000000;
  }

  const pSlider = document.getElementById('nwProperty');
  if (pSlider) {
    pSlider.max = maxPropertyPrice;
    pSlider.value = overrideParams.property ?? defaultProperty;
  }

  const sliders = [
    { id: 'nwCash', val: overrideParams.cash },
    { id: 'nwStocks', val: overrideParams.stocks },
    { id: 'nwPf', val: overrideParams.pf },
    { id: 'nwOtherAssets', val: overrideParams.otherAssets },
    { id: 'nwHomeLoan', val: overrideParams.homeLoan },
    { id: 'nwAutoLoan', val: overrideParams.autoLoan },
    { id: 'nwCreditDebt', val: overrideParams.creditDebt },
  ];

  sliders.forEach((s) => {
    const el = document.getElementById(s.id);
    if (el && s.val !== null) {
      el.value = s.val;
    }
  });
}

function recalculateNw() {
  const params = getNwInputs();
  updateDisplays(params);
  updateNwUrlParams(params);
  const result = calculateNw(params);
  renderNwResults(result, params);
}

function initNwCalculator() {
  if (!document.getElementById('nwCash')) return;

  const urlParams = parseNwUrlParams();

  initCountry((country) => {
    applyNwCountryRanges(country, urlParams);
    recalculateNw();
  });

  const inputs = ['nwCash', 'nwStocks', 'nwPf', 'nwProperty', 'nwOtherAssets', 'nwHomeLoan', 'nwAutoLoan', 'nwCreditDebt'];
  inputs.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', recalculateNw);
      el.addEventListener('change', recalculateNw);
    }
  });

  const exportBtn = document.getElementById('exportNwCsv');
  if (exportBtn) {
    exportBtn.addEventListener('click', exportNwCsv);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initNwCalculator();
});
